module.exports = __webpack_public_path__ + "img/bg-d.a4be6c44.png";